module.exports = __webpack_public_path__ + "img/logop3.ffabc099.png";